/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type VehicleGoalDtoPriorityLevel = (typeof VehicleGoalDtoPriorityLevel)[keyof typeof VehicleGoalDtoPriorityLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VehicleGoalDtoPriorityLevel = {
  low: "low",
  high: "high",
} as const;
